import { render } from "./Confirm.vue?vue&type=template&id=242c175c"
import script from "./Confirm.vue?vue&type=script&lang=js"
export * from "./Confirm.vue?vue&type=script&lang=js"
script.render = render

export default script